import { render, staticRenderFns } from "./RightTip.vue?vue&type=template&id=303809b3&"
import script from "./RightTip.vue?vue&type=script&lang=js&"
export * from "./RightTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports